import BaseApiService from "service/BaseApi.service";

const DEFAULT_PATH = "/v1/release";

class VersionService extends BaseApiService {
  /**===============================
            Constructor
  ================================**/
  constructor() {
    super();
    // this.defaultLimit = //Put service specific default limit here;
  }

  //Properties
  private defaultPath: string = DEFAULT_PATH;

  /**===============================
          Standard API Calls
  ================================**/

  getVersion() {
    const url = `${this.defaultPath}`;
    return this.makeGetRequestWithAuth(url);
  }

  /**===============================
        Custom API Calls
  ================================**/

  /**===============================
          Standard Transformers
  ================================**/
}

export default new VersionService();
